import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import MenuDotsIcon from '../icons/MenuDotsIcon';
import CopyIcon from '../icons/CopyIcon'; // Import CopyIcon
import { useClickOutside } from '../../hooks/useClickOutside';
import { copyToClipboard } from '../../utils/textUtils'; // Import copyToClipboard

const BookmarkMenuContainer = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  opacity: 0;
  transition: opacity 0.2s ease;
  z-index: 2;
`;

const MenuButton = styled.button`
  background: #22272B;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: #B6C2CF;
  border-radius: 8px;

  svg {
    display: block;
  }
`;

const MenuDropdown = styled.div`
  position: absolute;
  right: 0;
  top: 100%;
  background: #282E33;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  min-width: 130px;
  margin-top: 4px;
  display: ${props => props.isOpen ? 'block' : 'none'};
  overflow: hidden;
`;

const MenuItem = styled.button`
  width: 100%;
  padding: 8px 12px;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
  color: ${props => props.isDanger ? '#ef5350' : '#B6C2CF'};
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  
  &:hover {
    background: ${props => props.isDanger ? '#ffebee' : '#3B444C'};
  }
`;

// Add bookmarkUrl to the component props
const BookmarkMenu = ({ onEdit, onRemove, bookmarkUrl }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  
  useClickOutside(menuRef, () => setIsOpen(false));

  const handleMenuClick = (e) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  const handleAction = (action) => (e) => {
    e.stopPropagation();
    setIsOpen(false);
    if (action === 'edit') {
      onEdit();
    } else if (action === 'delete') {
      onRemove(e); // Pass the event object to onRemove
    } else if (action === 'copy') {
      if (bookmarkUrl) {
        copyToClipboard(bookmarkUrl);
      } else {
        console.warn('No bookmark URL provided to copy.');
        alert('No URL to copy.');
      }
    }
  };

  return (
    <BookmarkMenuContainer ref={menuRef} onClick={(e) => e.stopPropagation()} className="bookmark-menu">
      <MenuButton onClick={handleMenuClick} aria-label="Bookmark menu">
        <MenuDotsIcon />
      </MenuButton>
      <MenuDropdown isOpen={isOpen}>
        <MenuItem onClick={handleAction('edit')}>
          Edit Bookmark
        </MenuItem>
        {/* Add Copy menu item */}
        <MenuItem onClick={handleAction('copy')}>
          <CopyIcon /> Copy Link
        </MenuItem>
        <MenuItem onClick={handleAction('delete')} isDanger>
          Delete Bookmark
        </MenuItem>
      </MenuDropdown>
    </BookmarkMenuContainer>
  );
};

export default BookmarkMenu;